import Select from "../../../components/inputs/select/select";
import useInput from "../hooks/use-input";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect, useEffect } from "react";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormSelect = (props) => {
  const { ref, bind } = useInput(props);
  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const {
    translatedLabel,
    translatedPlaceholder,
    translatedOptions = [],
  } = getTranslatedProps(props);

  const { onValueChange } = props;
  useLayoutEffect(() => {
    if (!props.ignore) {
      register(props.id || props.name, ref);
      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  useEffect(() => {
    //console.log(`Value changed for ${props.id || props.name}:`, bind.value);
    if (onValueChange) {
      onValueChange(bind.value);
    }
  }, [bind.value]);

  return (
    <Select
      {...props}
      {...bind}
      label={translatedLabel}
      placeholder={translatedPlaceholder}
      options={translatedOptions}
    />
  );
};


export default FormSelect;
